import React from "react";
import { withRouter } from "react-router-dom";
import CONSTANT from "./../../../constant";
import Loader from "./../../../component/common/Loader";
import AparEmployeeHeader, { normalizeManagers, mergeManagerData } from "./../../../component/common/AparEmployeeHeader";
import { getKpiReport, getKpiTaskGrade, saveKpiTaskGrade, updateKpiTaskGrade } from "./../../../actions/AppraisalCycleAction";

class aparReviewingManagerForm1 extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      showLoader: false,
      employeeData: null,
      kpiReportId: null,
      hasExistingGrades: false,
      isSubmitted: false,
      isMouApplicable: false,
      mouTask: null,
      otherKeyTasks: [],
      // Reporting Authority grades (read-only)
      repMouGrade: '',
      repMouWeightedGrade: 0,
      repTaskGrades: [] as any[],
      // Reviewing Authority grading
      mouGrade: '',
      mouWeightedGrade: 0,
      taskGrades: [] as any[],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Assessment of Achievements - " + CONSTANT.organisation.name;

    const locationState = this.props.location?.state || {};
    const { kpiReportId: passedKpiReportId, employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo } = locationState;
    const employeeData = { employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo, ...normalizeManagers(locationState) };

    this.setState({ employeeData, showLoader: true });

    // Fetch HR's KPI report to show employee data
    if (employeeCode && effectiveFrom) {
      getKpiReport({ employeeCode, effectiveFrom, reportType: 'employee' }).then((res: any) => {
        const report = res?.result || null;
        if (report) {
          const kpiReportId = report.id || passedKpiReportId || null;
          const mouTask = report.tasks?.find((t: any) => t.particular === '*)') || null;
          const otherTasks = report.tasks?.filter((t: any) => t.particular !== '*)') || [];
          const isMouApplicable = !!mouTask;

          this.setState((prev: any) => ({
            kpiReportId,
            isMouApplicable,
            mouTask,
            otherKeyTasks: otherTasks,
            taskGrades: otherTasks.map((t: any) => ({ id: t.id, grade: '', weightedGrade: 0 })),
            repTaskGrades: otherTasks.map((t: any) => ({ id: t.id, grade: '', weightedGrade: 0 })),
            employeeData: { ...prev.employeeData, ...mergeManagerData(prev.employeeData, report) },
          }), () => {
            if (kpiReportId) {
              this.loadReportingGrades(kpiReportId);
            } else {
              this.setState({ showLoader: false });
            }
          });
        } else {
          this.setState({ showLoader: false });
        }
      });
    } else {
      this.setState({ showLoader: false });
    }
  }

  loadReportingGrades = (kpiReportId: any) => {
    getKpiTaskGrade({ kpiReportId, gradedByRole: "reporting" }).then((res: any) => {
      const resData = res?.result || res;
      const grades = resData?.grades || (Array.isArray(resData) ? resData : []);
      if (grades.length > 0) {
        const { mouTask, otherKeyTasks } = this.state;

        const gradeMap: any = {};
        grades.forEach((g: any) => {
          gradeMap[g.kpi_task_id] = g;
        });

        let repMouGrade = '';
        let repMouWeightedGrade = 0;
        if (mouTask && gradeMap[mouTask.id]) {
          repMouGrade = String(gradeMap[mouTask.id].absolute_grade || '');
          repMouWeightedGrade = parseFloat(gradeMap[mouTask.id].weighted_grade) || 0;
        }

        const repTaskGrades = otherKeyTasks.map((t: any) => {
          const existing = gradeMap[t.id];
          if (existing) {
            return { id: t.id, grade: String(existing.absolute_grade || ''), weightedGrade: parseFloat(existing.weighted_grade) || 0 };
          }
          return { id: t.id, grade: '', weightedGrade: 0 };
        });

        this.setState({ repMouGrade, repMouWeightedGrade, repTaskGrades }, () => {
          this.loadReviewingGrades(kpiReportId);
        });
      } else {
        this.loadReviewingGrades(kpiReportId);
      }
    }).catch(() => {
      this.loadReviewingGrades(kpiReportId);
    });
  };

  loadReviewingGrades = (kpiReportId: any) => {
    getKpiTaskGrade({ kpiReportId, gradedByRole: "reviewing" }).then((res: any) => {
      const resData = res?.result || res;
      const grades = resData?.grades || (Array.isArray(resData) ? resData : []);
      const isSubmitted = !!resData?.is_submitted;
      if (grades.length > 0) {
        const { mouTask, otherKeyTasks } = this.state;

        const gradeMap: any = {};
        grades.forEach((g: any) => {
          gradeMap[g.kpi_task_id] = g;
        });

        let mouGrade = '';
        let mouWeightedGrade = 0;
        if (mouTask && gradeMap[mouTask.id]) {
          mouGrade = String(gradeMap[mouTask.id].absolute_grade || '');
          mouWeightedGrade = parseFloat(gradeMap[mouTask.id].weighted_grade) || 0;
        }

        const taskGrades = otherKeyTasks.map((t: any) => {
          const existing = gradeMap[t.id];
          if (existing) {
            return { id: t.id, grade: String(existing.absolute_grade || ''), weightedGrade: parseFloat(existing.weighted_grade) || 0 };
          }
          return { id: t.id, grade: '', weightedGrade: 0 };
        });

        this.setState({ hasExistingGrades: true, isSubmitted, mouGrade, mouWeightedGrade, taskGrades, showLoader: false });
      } else {
        this.setState({ showLoader: false });
      }
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  handleMouGradeChange = (value: string) => {
    let grade = parseFloat(value) || 0;
    if (grade > 10) grade = 10;
    if (grade < 0) grade = 0;
    const clampedValue = grade > 0 ? String(grade) : value;
    const weightage = parseFloat(this.state.mouTask?.weightage) || 0;
    this.setState({ mouGrade: clampedValue, mouWeightedGrade: (weightage * grade) / 10 });
  };

  handleTaskGradeChange = (index: number, value: string) => {
    let grade = parseFloat(value) || 0;
    if (grade > 10) grade = 10;
    if (grade < 0) grade = 0;
    const clampedValue = grade > 0 ? String(grade) : value;
    const taskGrades = [...this.state.taskGrades];
    const weightage = parseFloat(this.state.otherKeyTasks[index]?.weightage) || 0;
    taskGrades[index] = { ...taskGrades[index], grade: clampedValue, weightedGrade: (weightage * grade) / 10 };
    this.setState({ taskGrades });
  };

  calculateTasksTotal = () => {
    return this.state.taskGrades.reduce((sum: number, t: any) => sum + (t.weightedGrade || 0), 0);
  };

  calculateRepTasksTotal = () => {
    return this.state.repTaskGrades.reduce((sum: number, t: any) => sum + (t.weightedGrade || 0), 0);
  };

  validateGrades = () => {
    const { isMouApplicable, mouGrade, taskGrades } = this.state;

    if (isMouApplicable && (!mouGrade || parseFloat(mouGrade) <= 0)) {
      alert("Please enter a grade for MoU target.");
      return false;
    }

    for (let i = 0; i < taskGrades.length; i++) {
      if (!taskGrades[i].grade || parseFloat(taskGrades[i].grade) <= 0) {
        alert(`Please enter a grade for task ${i + 1}.`);
        return false;
      }
    }

    return true;
  };

  buildGradesPayload = () => {
    const { kpiReportId, isMouApplicable, mouTask, mouGrade, taskGrades } = this.state;
    const grades: any[] = [];
    if (isMouApplicable && mouTask) {
      grades.push({ kpiTaskId: mouTask.id, absoluteGrade: parseFloat(mouGrade) || 0 });
    }
    taskGrades.forEach((t: any) => {
      grades.push({ kpiTaskId: t.id, absoluteGrade: parseFloat(t.grade) || 0 });
    });
    return { kpiReportId, gradedByRole: "reviewing", grades };
  };

  callGradeApi = (callback: () => void) => {
    const { kpiReportId, hasExistingGrades } = this.state;
    if (!kpiReportId) {
      alert("KPI Report ID not found. Please go back and try again.");
      return;
    }
    this.setState({ showLoader: true });
    const payload = this.buildGradesPayload();
    const apiCall = hasExistingGrades ? updateKpiTaskGrade(payload) : saveKpiTaskGrade(payload);
    apiCall.then(() => {
      this.setState({ showLoader: false, hasExistingGrades: true });
      callback();
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  handleSaveDraft = () => {
    this.callGradeApi(() => {
      alert('Saved as draft.');
    });
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    if (!this.validateGrades()) return;

    const { employeeData, kpiReportId } = this.state;
    this.callGradeApi(() => {
      this.props.history.push({
        pathname: CONSTANT.component.aparReviewingManagerForm2.url,
        state: { ...employeeData, kpiReportId },
      });
    });
  };

  render() {
    const { showLoader, employeeData, isMouApplicable, mouTask, otherKeyTasks, mouGrade, mouWeightedGrade, taskGrades,
      repMouGrade, repMouWeightedGrade, repTaskGrades, isSubmitted } = this.state;

    const tasksTotal = this.calculateTasksTotal();
    const grandTotal = (isMouApplicable ? mouWeightedGrade : 0) + tasksTotal;

    const repTasksTotal = this.calculateRepTasksTotal();
    const repGrandTotal = (isMouApplicable ? repMouWeightedGrade : 0) + repTasksTotal;

    return (
      <div className="container mx-auto px-4 py-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">

                <div className="row mb-3">
                  <div className="col-md-8">
                    <h1 className="page-title">Assessment of Achievements</h1>
                  </div>
                  <div className="col-md-4 text-right">
                    <button type="button" className="btn btn-sm cancel-button" onClick={() => this.props.history.goBack()}>
                      <i className="fa fa-arrow-left mr-2" />Back
                    </button>
                  </div>
                </div>
                <AparEmployeeHeader {...employeeData} detailViewerRole="reviewing" kpiReportId={this.state.kpiReportId} />

                {showLoader && <Loader />}

                {!showLoader && !this.state.kpiReportId && (
                  <div>
                    <div className="alert alert-warning d-flex align-items-center" role="alert">
                      <i className="fa fa-exclamation-triangle mr-2" style={{ fontSize: '1.5rem' }} />
                      <div>
                        <strong>KPI Report Not Available</strong>
                        <p className="mb-0 mt-1">
                          The KPI report for this employee has not been uploaded by HR yet.
                          Please contact HR to upload the KPI report before proceeding with the appraisal.
                        </p>
                      </div>
                    </div>
                    {/* <div className="d-flex justify-content-end gap-2 mt-3">
                      <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.history.goBack()}>
                        <i className="fa fa-arrow-left mr-1" />Back
                      </button>
                    </div> */}
                  </div>
                )}

                {isSubmitted && (
                  <div className="alert alert-success mt-2">
                    <i className="fa fa-check-circle mr-1" /> This assessment has been submitted and is now view-only.
                  </div>
                )}

                {this.state.kpiReportId && <div>
                  <h2 className="fs-5 fw-bold border-bottom pb-2 mb-4">
                    Assessment of Achievements against Targets
                  </h2>

                  <p className="text-muted mb-3">
                    This assessment should rate the officer vis-à-vis his peers and not the general population. Grades should be assigned on a scale of <strong>1-10</strong>, in maximum of <strong>2 decimal numbers</strong>, with <strong>10</strong> referring to the best grade and <strong>1</strong> to the lowest grade. Weightage to this Section will be <strong>75%</strong>.
                  </p>

                  <div className="table-responsive mb-2">
                    <table className="table table-bordered table-sm align-middle" style={{ tableLayout: 'fixed', width: '100%' }}>
                      <colgroup>
                        <col style={{ width: '28%' }} />
                        <col style={{ width: '9%' }} />
                        <col style={{ width: '13%' }} />
                        <col style={{ width: '13%' }} />
                        <col style={{ width: '13%' }} />
                        <col style={{ width: '13%' }} />
                      </colgroup>
                      <thead className="table-light">
                        <tr>
                          <th rowSpan={2} className="align-middle">Particulars</th>
                          <th rowSpan={2} className="text-center align-middle">Weightage (a)</th>
                          <th colSpan={2} className="text-center">Reporting Authority</th>
                          <th colSpan={2} className="text-center">Reviewing Authority</th>
                        </tr>
                        <tr>
                          <th className="text-center">Absolute Grade (b)</th>
                          <th className="text-center">Weighted Grade (c = a×b/10)</th>
                          <th className="text-center">Absolute Grade (b)</th>
                          <th className="text-center">Weighted Grade (c = a×b/10)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="table-secondary">
                          <td colSpan={6} className="fw-semibold">I – MoU Targets</td>
                        </tr>

                        {isMouApplicable && mouTask ? (
                          <tr>
                            <td style={{ wordBreak: 'break-word' }}>
                              <div className="d-flex align-items-center gap-1">
                                <span className="text-muted fw-semibold" style={{ minWidth: '28px', flexShrink: 0 }}>*)</span>
                                <span>{mouTask.task_description || ''}</span>
                              </div>
                            </td>
                            <td className="text-center">{mouTask.weightage || ''}</td>
                            <td className="text-center">{repMouGrade || '—'}</td>
                            <td className="text-center">{repMouWeightedGrade > 0 ? repMouWeightedGrade.toFixed(2) : '—'}</td>
                            <td className="text-center">
                              <input
                                type="number"
                                step="0.01"
                                min="1"
                                max="10"
                                value={mouGrade}
                                onChange={(e) => this.handleMouGradeChange(e.target.value)}
                                className="form-control form-control-sm text-center"
                                placeholder="0.00"
                                required
                                disabled={isSubmitted}
                              />
                            </td>
                            <td className="text-center">{mouWeightedGrade.toFixed(2)}</td>
                          </tr>
                        ) : (
                          <tr>
                            <td colSpan={6} className="text-muted fst-italic ps-3 small">MoU not applicable</td>
                          </tr>
                        )}

                        <tr className="table-secondary">
                          <td colSpan={6} className="fw-semibold">II – Other Key Assigned Tasks flowing from KPI</td>
                        </tr>

                        {otherKeyTasks.length === 0 ? (
                          <tr>
                            <td colSpan={6} className="text-muted fst-italic ps-3 small">No tasks available.</td>
                          </tr>
                        ) : (
                          otherKeyTasks.map((task: any, idx: number) => (
                            <tr key={task.id}>
                              <td style={{ wordBreak: 'break-word' }}>
                                <div className="d-flex align-items-center gap-1">
                                  <span className="text-muted fw-semibold" style={{ minWidth: '28px', flexShrink: 0 }}>{task.particular}</span>
                                  <span>{task.task_description || ''}</span>
                                </div>
                              </td>
                              <td className="text-center">{task.weightage || ''}</td>
                              <td className="text-center">{repTaskGrades[idx]?.grade || '—'}</td>
                              <td className="text-center">{repTaskGrades[idx]?.weightedGrade > 0 ? repTaskGrades[idx].weightedGrade.toFixed(2) : '—'}</td>
                              <td className="text-center">
                                <input
                                  type="number"
                                  step="0.01"
                                  min="1"
                                  max="10"
                                  value={taskGrades[idx]?.grade || ''}
                                  onChange={(e) => this.handleTaskGradeChange(idx, e.target.value)}
                                  className="form-control form-control-sm text-center"
                                  placeholder="0.00"
                                  required
                                  disabled={isSubmitted}
                                />
                              </td>
                              <td className="text-center">{(taskGrades[idx]?.weightedGrade || 0).toFixed(2)}</td>
                            </tr>
                          ))
                        )}

                        <tr className="table-light fw-semibold">
                          <td colSpan={2} className="text-end pe-3">Total (i to v)</td>
                          <td className="text-center"></td>
                          <td className="text-center">{repTasksTotal > 0 ? repTasksTotal.toFixed(2) : '—'}</td>
                          <td className="text-center"></td>
                          <td className="text-center">{tasksTotal > 0 ? tasksTotal.toFixed(2) : '—'}</td>
                        </tr>
                        <tr className="table-secondary fw-bold">
                          <td colSpan={2} className="text-end pe-3">Grand Total I & II <small className="fw-normal">(Weightage: 75)</small></td>
                          <td className="text-center"></td>
                          <td className="text-center">{repGrandTotal > 0 ? repGrandTotal.toFixed(2) : '—'}</td>
                          <td className="text-center"></td>
                          <td className="text-center">{grandTotal.toFixed(2)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="border p-2 mt-2 mb-3 fst-italic text-danger">
                    <p className="mb-1">Weighted grade is to be computed by multiplying the absolute grade by the weight.</p>
                    <p className="mb-0">Overall grading is to be computed by summing up the weighted grade and rounding off to 2 decimals.</p>
                  </div>

                  <div className="text-muted mt-3 mb-3">
                    <p className="mb-1"><sup>1</sup> The weightage for MoU targets is 75 for Chief Executives, 50 for Functional Directors and Executives at E9 &amp; E8 level.</p>
                    <p className="mb-1"><sup>2</sup> The final MoU score based on audited accounts conveyed by DPE should be filled in this space.</p>
                    <p className="mb-0"><sup>3</sup> The weightage for other assigned tasks flowing from KPI is nil for Chief Executives and 25 for Functional Director &amp; Executives at E9 &amp; E8 level.</p>
                  </div>

                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.history.goBack()}>
                      Back
                    </button>
                    {!isSubmitted && (
                      <button type="button" className="btn btn-secondary" onClick={this.handleSaveDraft} disabled={showLoader}>
                        {showLoader ? "Saving..." : "Save Draft"}
                      </button>
                    )}
                    {!isSubmitted && (
                      <button type="button" className="btn btn-primary" onClick={this.onSubmit} disabled={showLoader}>
                        {showLoader ? "Saving..." : "Save & Next"} <i className="fa fa-arrow-right ml-1" />
                      </button>
                    )}
                    {isSubmitted && (
                      <button type="button" className="btn btn-primary" onClick={() => {
                        const { employeeData, kpiReportId } = this.state;
                        this.props.history.push({
                          pathname: CONSTANT.component.aparReviewingManagerForm2.url,
                          state: { ...employeeData, kpiReportId },
                        });
                      }}>
                        Next <i className="fa fa-arrow-right ml-1" />
                      </button>
                    )}
                  </div>
                </div>}

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(aparReviewingManagerForm1);
